module.exports = __webpack_public_path__ + "static/fowf-jonathan-color-ce187a31035472bb9c9b970370d880fd.jpg";